import React from "react";
import { Helmet } from "react-helmet";
import ListFormTemplate from "../../PageTemplate/ListFormTemplate";
import { config } from "../../../utils/config";
import { getCookie } from "../../../utils/cookieHandler";
import useCompanyLogic from "./useCompanyLogic";

const columns = [
  { field: "name", label: "Name", allowSorting: true },
  {
    field: "country",
    label: "Country",
    allowSorting: true,
    showInFilter: true,
  },
  { field: "email", label: "Email", allowSorting: true },
  { field: "phone", label: "Phone Number", allowSorting: true },
  {
    field: "has_pending_billing_events",
    label: "Bill",
    allowSorting: true,
    type: "status",
    values: {
      "True": "text-orange-700 ring-orange-600/20 bg-orange-50",
      "False": "text-green-700 ring-green-600/20 bg-green-50",
    },
    displayValues: {
      "True": "Pending",
      "False": "Billed",
      "": "N/A",
    },
    showInFilter: true,
  },
];

const CompanyPage = () => {
  const { apiRoute, addRoles, deleteRoles, editRoles, initFields } =
    useCompanyLogic();

  const handleBulkBilling = async ({ selectedItems, businessDateTime }) => {
    const companyIds = selectedItems.map((item) => item.id);
    const response = await fetch(
      `${config.apiUrl}/api/companies/bulk-sequence`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${getCookie("_AT")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          companyIds,
          businessDate: businessDateTime,
        }),
      }
    );

    const result = await response.json();

    if (!result.success) {
      throw new Error(result.message || "Failed to sequence companies");
    }

    return {
      ...result,
      message: `Successfully sequenced ${result.successCount} companies`,
    };
  };

  const bulkActionsConfig = {
    enabled: true,
    nameField: "name",
    buttonLabel: "Bill",
    onAction: handleBulkBilling,
  };

  return (
    <div>
      <Helmet>
        <title>Admin | Glide</title>
        <meta name="description" content="Welcome to the Companies." />
      </Helmet>
      <ListFormTemplate
        tableNameInDb={"company"}
        apiRoute={apiRoute}
        columns={columns}
        fields={initFields}
        createRoles={addRoles}
        deleteRoles={deleteRoles}
        editRoles={editRoles}
        bulkActions={bulkActionsConfig}
        enhancedTable={true}
      />
    </div>
  );
};

export default CompanyPage;
